import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { connect } from 'react-redux';

const withRoutingProps = (Component, extraProps) => {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return (
      <Component
        {...props}
        {...(extraProps ?? {})}
        params={params}
        location={location}
        navigate={navigate}
        screenSizeObj={props?.screenSizeObj ?? {}}
        {...(props?.themeArr || {})}
      />
    );
  }
  const mapStateToProps = state => ({
    themeArr: state?.mainlayout?.themeArr,
    screenSizeObj: state.mainlayout?.screenSizeObj
  });
  return connect(mapStateToProps)(ComponentWithRouterProp);
};

export default withRoutingProps;
